// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'id',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'user',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'prize',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'prize_draw',
    Object: 'value',
    label: '',
    width: '150'
  }, {
    prop: 'name',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'prizeable',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'image',
    label: '',
    width: '150',
    img: true
  }, {
    prop: 'status',
    label: '',
    Object: 'value',
    width: '150'
  }]
}
